var render = function render(){var _vm=this,_c=_vm._self._c;return _c('model',{attrs:{"check_permissions":false,"model_name":"discount"}})
}
var staticRenderFns = []

export { render, staticRenderFns }